// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__VBOhM","toggle":"style_toggle__oFmlj","icon":"style_icon__na3GO","menu":"style_menu__jIY2p"};